module.exports = __webpack_public_path__ + "img/title-bg.31650f7e.png";